import EngagmentAndInsights from "@/views/EngagementInsights/EngagementAndInsights.vue";
import EngagementAndInsightsPost from "@/views/EngagementInsights/EngagementAndInsightsPost.vue";
import EngagementAndInsightsEditPost from "@/views/EngagementInsights/EngagementAndInsightsEditPost.vue";
const CalenderRoutes = [
  {
    path: "/engagement-insights",
    name: "EngagementAndInsights",
    component: EngagmentAndInsights,
    meta: {
      title: "Engagement & Insights",
      description: "",
      
      permissions: [
        "engagement-insights.create",
        "engagement-insights.read",
        "engagement-insights.update",
        "engagement-insights.delete",
      ],
    },
  },
  {
    path: "/post/:id/:platform/engagement-insights",
    name: "EngagementAndInsightsPost",
    component: EngagementAndInsightsPost,
    meta: {
      title: "Engagement & Insights Post",
      description: "",
      
      permissions: [
        "engagement-insights.create",
        "engagement-insights.read",
        "engagement-insights.update",
        "engagement-insights.delete",
      ],
    },
  },
  {
    path: "/post/edit/:id/:platform/engagement-insights",
    name: "EngagementAndInsightsEditPost",
    component: EngagementAndInsightsEditPost,
    meta: {
      title: "Engagement & Insights Edit Post",
      description: "",
      
      permissions: [
        "engagement-insights.create",
        "engagement-insights.read",
        "engagement-insights.update",
        "engagement-insights.delete",
      ],
    },
  },
];

export default CalenderRoutes;
